import { combineReducers } from 'redux';

import ServedItemsToSite from './servedItemsToSite/reducer';

export default combineReducers({
  ServedItemsToSite,
});



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/state/reducer.js